<template>
  <v-container>
    <equipment-tab></equipment-tab>
    <v-container v-if="equipmentProfile && equipmentProfile.equipTag"
      ><material-card
        icon="mdi-book-open-page-variant"
        color="primary"
        inline
        class="px-5 my-12 py-3"
      >
        <template v-slot:after-heading>
          <div class="title text-no-wrap font-weight-bold">
            {{ $t("equipmentProfile.equipment") }}
            {{ equipmentProfile.equipTag }}
          </div>
        </template>
        <v-row>
          <v-col cols="12" md="8">
            <v-container>
              <base-subheading
                :subheading="$t('dashboard.operationalValues')"
              />
              <v-simple-table v-if="equipmentProfile && equipmentProfile.plant">
                <v-btn
                  v-if="$store.getters['auth/adminAndUp']"
                  @click="
                    $router.push({
                      name: 'EquipmentProfile/EditOperationalValues',
                      params: { id: equipmentProfile.id }
                    })
                  "
                  fab
                  color="#730D0B"
                  absolute=""
                  top
                  right=""
                >
                  <v-icon color="white">mdi-pencil</v-icon>
                </v-btn>

                <tbody>
                  <tr v-for="opVal in operationalValues" :key="opVal.code">
                    <td class="font-weight-bold">
                      {{ $t(`variables.${opVal.code}`) }}
                    </td>
                    <template v-if="opVal.type !== 'unique'">
                      <td>
                        {{
                          transformUnit(opVal.value, opVal.type, opVal.unit)
                            | fiveCyphers(opVal.type)
                            | ifExponential(opVal.type)
                        }}
                      </td>
                      <td>
                        <v-select
                          v-model="opVal.unit"
                          :items="unitTypes[opVal.type]"
                          :label="opVal.type | capitalize"
                        ></v-select>
                      </td>
                    </template>
                    <template v-else>
                      <td>
                        {{ opVal.value }}
                      </td>
                      <td>
                        {{ opVal.unit }}
                      </td>
                    </template>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-container>
          </v-col>
        </v-row>
      </material-card></v-container
    ></v-container
  >
</template>

<script>
import { mapState } from "vuex";
import transformValue from "@/mixins/readValues";
import { unitList } from "@/settings/unitTypes";
export default {
  data() {
    return {
      unitTypes: unitList
    };
  },
  components: {
    "material-card": () => import("@/components/MaterialCard.vue")
  },
  mixins: [transformValue],
  computed: {
    operationalValues() {
      return this?.equipmentProfile?.operationalValues;
    },
    ...mapState("equipments", ["equipmentProfile"]),
    ...mapState("auth", ["user"])
  },
  async created() {
    const loading = this.$vs.loading({
      background: "#730D0B",
      color: "rgb(255, 255, 255)",
      opacity: 1,
      type: "square",
      text: ""
    });
    try {
      await this.$store.dispatch(
        "equipments/bindAnEquipment",
        this.$route.params.id
      );
      this.operationalValues?.map(opVal => {
        opVal.unit = this.globalInitialUnit(opVal.type);
      });
      await this.$store.dispatch("events/bindEvents", this.$route.params.id);
      loading.close();
    } catch (error) {
      this.$dialog.notify.error(error, {
        position: "top-right",
        timeout: 5000
      });
    }
  },

  methods: {}
};
</script>
